import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from '@/api/core/baseApi'; // RTK Query API

// Import reducers from feature directories
import messagesReducer from '../../features/messaging/store/messagesSlice';
import settingsReducer from '../../features/settings/store/settingsSlice';
import notificationsReducer from '../../features/notifications/store/notificationSlice';

// Import core slices
import uiReducer from './slices/uiSlice';
import userProfileReducer from './slices/userProfileSlice';
import messagingUiReducer from './slices/messagingUiSlice';
import teamsUiReducer from './slices/teamsUiSlice';
import teamUnreadReducer from './slices/teamUnreadSlice';
import bootReducer from './slices/bootSlice';

// Define the reducer object
export const reducers = {
  [baseApi.reducerPath]: baseApi.reducer,
  // Feature-specific reducers
  messages: messagesReducer,
  settings: settingsReducer,
  notifications: notificationsReducer,
  // Core reducers
  ui: uiReducer,
  userProfile: userProfileReducer,
  messagingUi: messagingUiReducer,
  teamsUi: teamsUiReducer,
  teamUnread: teamUnreadReducer,
  boot: bootReducer,
};

const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;